<template>
  <v-card flat color="transparent">
    <v-subheader class="display-3">行車公里</v-subheader>

    <v-card-text>
      <v-row>
        <v-col class="display-3 text-center">
          約 {{ Math.round(taxitotalfare) }} 港元
        </v-col>
      </v-row>
      <v-row>
        <v-col class="display-1 text-center"> {{ slider }} 公里 </v-col>
      </v-row>

      <v-row>
        <v-col class="pr-4">
          <v-slider
            v-model="slider"
            class="align-center"
            :max="max"
            :min="min"
            hide-details
            step="1"
            thumb-label="always"
            persistent-hint
            ticks
            :thumb-size="54"
          >
          </v-slider>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      min: 2,
      max: 90,
      slider: 20
    };
  },
  computed: {
    taxitotalfare() {
      var km = this.slider;
      var waiting = km * 1.2;
      if (km <= 2) return 24;
      var payunit = (km - 2) * 5;
      var payment = 24 + payunit * 1.7;
      if (payment >= 83.5) {
        return 83.5 + (payunit - 35) * 1.2 + waiting * 1.7;
      } else {
        return payment;
      }
    }
  }
};
</script>
